import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import authApi from "../../api/authApi";
import { getLabel } from "../../tools/Dictionary";
import Global from "../../Global/Global";

import "./Auth.css";
import logo from "../../images/Innovair_logo.png";

const AuthReset = (props) => {


  //Props
  //const IsDesktop = props.IsDesktop;

  //State
  const [form, setForm] = useState({
    password: "",
    passwordRepeat: "",
  });
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Password Input
  const onChangePassword = (e) =>
  {

    let password = e.target.value;

    onValidateField("password", password); //Validate field value

    setForm(form => ({
      ...form,
      password
    }));

  };

  //Password repeat Input
  const onChangePasswordRepeat = (e) =>
  {

    let passwordRepeat = e.target.value;

    onValidateField("passwordRepeat", passwordRepeat); //Validate field value

    setForm(form => ({
      ...form,
      passwordRepeat
    }));

  };

  //Validate field 
  const onValidateField = (field = "", value = "") =>
  {

    let currentError = { ...error };
    let currentField = "";


    currentField = "password";
    if (field == "password")
    {

      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty.";
      else if (currentValue.length > 200)//Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";
      else if (currentValue.length < 8)//Too few caracters
        currentError[currentField] = "Insufficient characters in the field. (min. 8 characters)";

    }

    currentField = "passwordRepeat";
    if (field == "passwordRepeat")
    {

      //If value is sent, otherwrise take from form state
      currentError[currentField] = "";
      const currentValue = field === "" ? form[currentField] : value;

      if (currentValue == "" || !currentValue)
        currentError[currentField] = "This field can't be empty.";
      else if (currentValue.length > 200)//Too many caracters
        currentError[currentField] = "This field has exceeded the character limit.";
      else if (currentValue.length < 8)//Too few caracters
        currentError[currentField] = "Insufficient characters in the field. (min. 8 characters)";

    }

    //Validate password
    if (field === "")
    {

      currentError["password"] = "";
      currentError["passwordRepeat"] = "";

      // Set an error message if the field is empty or falsy
      if (!form.password)
        currentError["password"] = "This field can't be empty.";
      if (!form.passwordRepeat)
        currentError["passwordRepeat"] = "This field can't be empty.";

      // If passwords aren't empty
      if (form.password && form.passwordRepeat)
      {


        if (form.password.length > 200) //Too many caracters
          currentError["password"] = "This field has exceeded the character limit.";
        if (form.passwordRepeat.length > 200) //Too many caracters
          currentError["passwordRepeat"] = "This field has exceeded the character limit.";

        if (form.password.length < 8)//Too few caracters
          currentError["password"] = "Insufficient characters in the field. (min. 8 characters)";
        if (form.passwordRepeat.length < 8) //Too few caracters
          currentError["passwordRepeat"] = "Insufficient characters in the field. (min. 8 characters)";

        //If password doesnt match
        if (currentError["password"] == "" && currentError["passwordRepeat"] == "" && form.password != form.passwordRepeat)
          currentError["passwordRepeat"] = "Passwords must match.";
      }


    }




    setError(currentError);

    let valid = true;

    for (let key in currentError)
    {
      if (currentError.hasOwnProperty(key))
      {
        if (currentError[key] !== "")
          valid = false;
      }
    }



    return valid;

  };

  const onClickSubmit = async () =>
  {

    if (!onValidateField())
    {
      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
      return;
    }

    try
    {

      setLoading(true);

      let response = await authApi.resetPassword(form);

      if (response.Error)
      {
        setAlert({
          Title: getLabel("App", "Error"),
          Message: getLabel(response.Error.component, response.Error.label) || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        });

        setLoading(false);

        return;

      }

      

      setAlert({
        Title: getLabel("AuthReset", "Password modified"),
        Message: getLabel("AuthReset", "Your new password has been saved."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: onClickCancel,
        Display: true
      });



    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setLoading(false);

    }

  }

  const onClickCancel = () =>
  {

    setAlert(alert => ({ ...alert, Display: false }))

    localStorage.setItem(Global.apiToken, "");
    localStorage.setItem(Global.apiTokenAI, "");
    window.location.reload()

  }


  return (
    <div className="auth_page_cont">
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="auth_page_title">
        <img src={logo} alt="logo" style={{ width: "50%" }} />
      </div>
      <div className="auth_cont">
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <div className="auth_cont_title">
          {getLabel("AuthReset", "Password Reset")}
        </div>
        <div className="auth_cont_body">
          <input
            className={"form-control auth_cont_login_input " + (error["password"] ? "auth_fill_row_input_error" : "")}
            type="password"
            placeholder={getLabel("AuthReset", "New password")}
            value={form.password}
            onChange={onChangePassword}
            disabled={loading}
          />
          {error["password"] &&
            <div className="auth_signup_row_error">
              {getLabel("AuthSignup", error["password"])}
            </div>
          }
          <input
            className={"form-control auth_cont_login_input " + (error["passwordRepeat"] ? "auth_fill_row_input_error" : "")}
            type="password"
            placeholder={getLabel("AuthReset", "Repeat new password")}
            value={form.passwordRepeat}
            onChange={onChangePasswordRepeat}
            disabled={loading}
          />
          {error["passwordRepeat"] &&
            <div className="auth_signup_row_error">
              {getLabel("AuthSignup", error["passwordRepeat"])}
            </div>
          }
        </div>
        <div className="auth_fill_footer" style={{ marginTop: "10px" }}>
          <input
            type="button"
            className="page_button auth_cont_login_button"
            value={getLabel("AuthSignup", "Submit")}
            onClick={onClickSubmit}
            disabled={loading}
          />
          <input
            type="button"
            className="page_button auth_cont_cancel_button"
            style={{ backgroundColor: "#424242" }}
            value={getLabel("AuthSignup", "Cancel")}
            onClick={onClickCancel}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default AuthReset